import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getRequests, getUsers } from "../../api/webServices";
import ItemsTable from "../ItemsTable";
import { CiSearch } from 'react-icons/ci';
import './Report.css';
import { formatDate, getPermissions } from "../../utils/various";
import { Navigate } from "react-router-dom";
import { utils, writeFile } from 'xlsx';
import moment from "moment";

const Report = () => {

    const [requestsList, setRequestsList] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const { sessionData } = useSelector(state => state.session);
    const [filteredData, setFilteredData] = useState(null);
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);
    const [data, setData] = useState([]);
    const ref = useRef();

    const getData = async () => {
        let res;
        res = await getRequests();
        let requests = res?.data;
        if (requests) {
            setRequestsList(requests);
        }
        res = await getUsers();
        let users = res?.data;
        if (users) {
            setUsersList(users);
        }
    }

    useEffect(() => {
        //create data with -> username, name, email, requestsQuantity using requestsList and usersList and join them with request.cabezalAsesor === user.name
        let newData = [];
        if (!dateFrom) {
            requestsList?.forEach(requestUnparsed => {
                let request = {};
                try {
                    request = JSON.parse(requestUnparsed.data);
                } catch (err) {
                    console.log(err);
                }
                let user = usersList?.find(user => user.name === request?.cabezalAsesor);
                if (user) {
                    let userIndex = newData.findIndex(userData => userData.username === user.username);
                    if (userIndex === -1) {
                        newData.push({
                            username: user.username,
                            name: user.name,
                            email: user.email,
                            requestsQuantity: 1,
                            date: requestUnparsed?.date
                        });
                    } else {
                        newData[userIndex].requestsQuantity++;
                    }
                }
            });
        } else {
            requestsList?.forEach(requestUnparsed => {
                let request = {};
                try {
                    request = JSON.parse(requestUnparsed.data);
                } catch (err) {
                    console.log(err);
                }
                if (!isBetweenDates(requestUnparsed?.date)) return;
                let user = usersList?.find(user => user.name === request?.cabezalAsesor);
                if (user) {
                    let userIndex = newData.findIndex(userData => userData.username === user.username);
                    if (userIndex === -1) {
                        newData.push({
                            username: user.username,
                            name: user.name,
                            email: user.email,
                            requestsQuantity: 1,
                            date: requestUnparsed?.date
                        });
                    } else {
                        newData[userIndex].requestsQuantity++;
                    }
                }
            });
        }

        setData(newData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestsList, usersList, dateFrom, dateTo])

    useEffect(() => {
        // Cargar requests
        const permissions = getPermissions(sessionData?.role);
        if (!permissions.admin) {
            return <Navigate to={'/'} replace={true} />
        }
        getData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isBetweenDates = (dateToCheck) => {
        if (dateFrom) {
            let parsedDateTo = dateTo ? new Date(dateTo) : new Date();
            parsedDateTo = formatDate(parsedDateTo, 'YYYY-MM-DD');
            let newDateFrom = new Date(dateFrom);
            let newRequestDate = moment(new Date(dateToCheck), 'DD/MM/YYYY').valueOf();
            newDateFrom = moment(dateFrom, 'YYYY-MM-DD').subtract(5, 'hours').valueOf();
            let newDateTo = moment(parsedDateTo, 'YYYY-MM-DD').add(5, 'hours').valueOf();
            return newDateFrom <= newRequestDate && newRequestDate <= newDateTo;
        }
        return false
    }


    const handleFilter = () => {
        let value = ref.current.value;
        if (value === "") {
            setFilteredData(null);
        } else {
            let filtered = data.filter(item => item.name?.toLowerCase().includes(value.toLowerCase()));
            setFilteredData(filtered);
        }
    }

    const handleExportExcel = () => {
        //dateFrom and dateTo in format DD/MM/YYYY
        let dataToExport = filteredData?.length > 0 ? filteredData : data;
        let parsedData = dataToExport?.map((item, index) => {
            let newItem = {};
            if (index === 0) {
                newItem = {
                    'Asesor': item.name,
                    'Cantidad de solicitudes': item.requestsQuantity,
                    ' ': ' ',
                    'Desde': dateFrom ? formatDate(new Date(dateFrom), 'DD/MM/YYYY') : ' ',
                    'Hasta': dateTo ? formatDate(new Date(dateTo), 'DD/MM/YYYY') : formatDate(new Date(), 'DD/MM/YYYY'),
                }
            } else {
                newItem = {
                    'Asesor': item.name,
                    'Cantidad de solicitudes': item.requestsQuantity,
                }
            }
            return newItem;
        })

        //in the first row, after columns insert one column empty and after dateFrom and dateTo


        let excelName = 'ReporteSolicitudes';
        if (dateFrom) {
            excelName += `_${dateFrom.toLocaleString().split(' ')[0].replaceAll('/', '-').replaceAll(',', '')}`;
        }
        let newDateTo = dateTo ? dateTo : formatDate(new Date(), 'YYYY-MM-DD');
        if (newDateTo) {
            excelName += `_${newDateTo.toLocaleString().split(' ')[0].replaceAll('/', '-').replaceAll(',', '')}`;
        }
        const workbook = utils.book_new();
        const worksheet = utils.json_to_sheet(parsedData);
        utils.book_append_sheet(workbook, worksheet, 'Datos');
        writeFile(workbook, `${excelName}.xlsx`);
    }

    return (
        <div className="flex flex-col items-center justify-center w-full h-full gap-20">
            <div className="w-[85%] bg-white h-[90%] my-auto rounded-2xl">
                <h2 className="2xl:py-8 2xl:leading-[75px] text-[30px] 2xl:text-[40px] mt-7 titleRequests">Reporte de solicitudes</h2>
                <div className="2xl:w-[65%] w-[80%] mx-auto mt-10">
                    <div className="flex flex-row items-center gap-3 px-6 mb-3 ">
                        <label htmlFor="dateFrom">Desde:</label>
                        <input type="date" className="" onChange={(e) => setDateFrom(e.target.value)} value={dateFrom}></input>
                        <label htmlFor="dateFrom">Hasta:</label>
                        <input type="date" className="" onChange={(e) => setDateTo(e.target.value)} value={dateTo}></input>
                    </div>
                    <div className="flex flex-row justify-between gap-3">
                        <div className="mx-5 searchReportContainer">
                            <p>Asesor:</p>
                            <input ref={ref} type="text" className="searchReportInput">
                            </input>
                            <button className="searchReportButton" onClick={handleFilter}><CiSearch size={24} /></button>
                        </div>
                        <button className="mx-5 newRequestButton" onClick={handleExportExcel}>Exportar</button>
                    </div>
                    <ItemsTable
                        type="report"
                        data={filteredData !== null ? filteredData : data}
                        disabled
                    />
                </div>
            </div>
        </div>
    )
}

export default Report;